<script>
  import MTableHeaderDefault from 'components/Data/Tables/MTable/headers/MTableHeaderDefault';
  import MTableCellDropdownTrigger from 'components/Data/Tables/MTable/cells/MTableCellDropdownTrigger';
  import MTableNestedRow from 'components/Data/Tables/MTable/MTableNestedRow';
  import MTableCellEmpty from 'components/Data/Tables/MTable/cells/MTableCellEmpty';

  export default {
    name: 'NestedTableMixin',
    props: {
      nested: {
        type: Boolean,
        default: false
      },
      activeNestedRows: {
        type: Array,
        default: Array
      },
      nestedColumns: {
        type: Array,
        default: Array
      },
      nestedData: {
        type: Object,
        default: Object
      },
      hasNestedTablePredicate: {
        type: Function,
        default: () => true
      },
      hideNestedTrigger: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      openedNestedRows: {
        get () {
          return this.activeNestedRows;
        },
        set (val) {
          this.$emit('changeNestedRows', val);
        }
      },
      computedNestedColumns () {
        return this.getComputedColumns(this.nestedColumns, true);
      },
      nestedColumnsFlat () {
        // by default load params from column above
        const regularColumns = this.columnsFlat;
        return this.computedNestedColumns.map((c, idx) => this.fillDefaultColumnData({
          ...regularColumns[idx],
          ...c,

          // get sticky parameters from upper cell, in nested table columns may have different names
          stickyParamKey: regularColumns[idx].itemKey
        }));
      },
      isAllNestedOpened () {
        return this.dataWithoutSummary.length === this.openedNestedRows.length && this.openedNestedRows.length > 0;
      }
    },
    mounted () {
      if (this.nested) {
        this.registerAfterRowRenderedProcessor(this.nestedTableRowPreprocessor);
        this.registerCellEventsListener('triggerNested', this.handleTableExpandTrigger);
        this.registerCellEventsListener('triggerNestedAll', this.handleTriggerAll);
      }
    },
    methods: {
      getNestedExpandTriggerColumnParams (isNestedTable) {
        if (this.nested && !this.hideNestedTrigger) {
          if (isNestedTable) {
            return this.fillDefaultColumnData({
              itemKey: 'expanded-nested',
              cellComponent: MTableCellEmpty,
              sticky: true
            });
          }
          return this.fillDefaultColumnData({
            itemKey: 'expanded',
            headerComponent: MTableHeaderDefault,
            cellComponent: MTableCellDropdownTrigger,
            align: 'center',
            minWidth: 24,
            resizable: false,
            static: true,
            sticky: true,
            uniqueKeyAttr: this.uniqueKeyAttr,
            isDropdownEnabledPredicate: this.isDropdownEnabledPredicate,
            on: {
              triggerDropdownState: this.handleTableExpandTrigger
            }
          });
        }
      },
      handleTableExpandTrigger (tableRow) {
        const rowUniqueKey = tableRow[this.uniqueKeyAttr];
        let opened = null;
        if (this.openedNestedRows.includes(rowUniqueKey)) {
          this.openedNestedRows = this.openedNestedRows.filter(i => i !== rowUniqueKey);
          opened = false;
        } else {
          this.openedNestedRows = [
            ...this.openedNestedRows,
            rowUniqueKey
          ];
          opened = true;
        }
        return this.$emit('nestedRowsToggle', [{id: rowUniqueKey, value: opened}]);
      },
      handleTriggerAll () {
        if (this.isAllNestedOpened) {
          this.openedNestedRows = [];
          return;
        }

        const openedIds = this.dataWithoutSummary.map(d => d[this.uniqueKeyAttr]);
        this.openedNestedRows = openedIds;
        this.$emit('nestedRowsToggle', openedIds.map(i => ({id: i, value: true})));
      },
      nestedTableRowPreprocessor (rows, h, tableRow, rowIndex, isNestedTable) {
        if (!this.hasNestedTablePredicate(tableRow) || isNestedTable) {
          return rows;
        }

        const rowUniqueKey = tableRow[this.uniqueKeyAttr];
        const rowNestedData = this.nestedData[rowUniqueKey] || [];

        const nestedRows = this.renderRows(
          h, rowNestedData, this.nestedColumnsFlat,
          true, `nested-cell-${rowIndex}`,
          `row-nested-${rowIndex}`, MTableNestedRow,
          {
            nestedParentId: rowUniqueKey
          }
        );

        return [...rows, ...nestedRows];
      }
    }
  };
</script>
